import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import resourcesToBackend from "i18next-resources-to-backend"
import LanguageDetector from "i18next-browser-languagedetector"

// Resources are autogenerated by backend. if missing: execute 'nuke GenerateFrontendResources' (alias 'npm run gfr') in CLI
// Also do this, after adding new resources to the backend (we have a Resources.resx file in app-server.Properties now,
// you can add resources there) DO NOT ADD RESOURCES IN FRONTEND
import dayjs from "dayjs"
import { ns, supportedLngs } from "./@resource-interfaces/i18nModuleAugment"

i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../src/locales/${namespace}/${language}/resources.json`)
    )
  )
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    partialBundledLanguages: true,
    ns,
    defaultNS: "app_server",
    // resources are initialised as empty, because we load them lazily
    resources: {},
    fallbackLng: "en",
    supportedLngs,
    interpolation: {
      escapeValue: false, // disable escaping, react already escapes by default and it would show the escaped value in the UI otherwise
    },
    // debug: import.meta.env.DEV
  })

// set dayjs locale to i18n language on language change
i18n.on("languageChanged", (lng) => {
  dayjs.locale(lng === "en" ? "en-gb" : lng)
})

export default i18n
